import React from 'react'
import Switch, { SwitchProps } from '@mui/material/Switch'

interface ISwitchComponentProps extends SwitchProps {
  name?: string
}

const SwitchComponent: React.FC<ISwitchComponentProps> = (props) => {
  return (
    <Switch
      {... props}
      name={props.name}
    />
  )
}

export default SwitchComponent
